<template>
  <div id="app">
    <layout></layout>
  </div>
</template>
<style>
</style>
<script>
  import Layout from './components/shared/layout/layout.vue'

  export default {
    name: 'App',
    data: function () {
      return {
      }
    },
    components: {
      'layout': Layout
    },
    methods: {
    }
  }


</script>



// WEBPACK FOOTER //
// src/App.vue